export enum PartnerApprovalEnum {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  NotApproved = 4
}

export interface PartnerApprovalEnumDisplayNames {
  [key: number]: string;
}

export const PartnerApprovalEnumDisplayNames: PartnerApprovalEnumDisplayNames = {
  [PartnerApprovalEnum.Pending]: 'في انتظار الاعتماد',
  [PartnerApprovalEnum.Approved]: 'تم قبول الطلب',
  [PartnerApprovalEnum.Rejected]: 'تم رفض الطلب',
  [PartnerApprovalEnum.NotApproved]: 'لم يتم الاعتماد',
};
